import { render, staticRenderFns } from "./bsj-set-GF-viewing-screen-modal.vue?vue&type=template&id=17db794d"
import script from "./bsj-set-GF-viewing-screen-modal.vue?vue&type=script&lang=js"
export * from "./bsj-set-GF-viewing-screen-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports